export default {
  '1': {
    'size'  : 248956422,
    'bands' : [
      { 'id': 'p11.1',  'start': 121700001, 'end': 123400000, 'type': 'acen'    },
      { 'id': 'p11.2',  'start': 120400001, 'end': 121700000, 'type': 'gneg'    },
      { 'id': 'p12',    'start': 117200001, 'end': 120400000, 'type': 'gpos50'  },
      { 'id': 'p13.1',  'start': 115500001, 'end': 117200000, 'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 111200001, 'end': 115500000, 'type': 'gpos50'  },
      { 'id': 'p13.3',  'start': 106700001, 'end': 111200000, 'type': 'gneg'    },
      { 'id': 'p21.1',  'start': 101800001, 'end': 106700000, 'type': 'gpos100' },
      { 'id': 'p21.2',  'start': 99300001,  'end': 101800000, 'type': 'gneg'    },
      { 'id': 'p21.3',  'start': 94300001,  'end': 99300000,  'type': 'gpos75'  },
      { 'id': 'p22.1',  'start': 91500001,  'end': 94300000,  'type': 'gneg'    },
      { 'id': 'p22.2',  'start': 87900001,  'end': 91500000,  'type': 'gpos75'  },
      { 'id': 'p22.3',  'start': 84400001,  'end': 87900000,  'type': 'gneg'    },
      { 'id': 'p31.1',  'start': 69300001,  'end': 84400000,  'type': 'gpos100' },
      { 'id': 'p31.2',  'start': 68500001,  'end': 69300000,  'type': 'gneg'    },
      { 'id': 'p31.3',  'start': 60800001,  'end': 68500000,  'type': 'gpos50'  },
      { 'id': 'p32.1',  'start': 58500001,  'end': 60800000,  'type': 'gneg'    },
      { 'id': 'p32.2',  'start': 55600001,  'end': 58500000,  'type': 'gpos50'  },
      { 'id': 'p32.3',  'start': 50200001,  'end': 55600000,  'type': 'gneg'    },
      { 'id': 'p33',    'start': 46300001,  'end': 50200000,  'type': 'gpos75'  },
      { 'id': 'p34.1',  'start': 43700001,  'end': 46300000,  'type': 'gneg'    },
      { 'id': 'p34.2',  'start': 39600001,  'end': 43700000,  'type': 'gpos25'  },
      { 'id': 'p34.3',  'start': 34300001,  'end': 39600000,  'type': 'gneg'    },
      { 'id': 'p35.1',  'start': 32300001,  'end': 34300000,  'type': 'gpos25'  },
      { 'id': 'p35.2',  'start': 29900001,  'end': 32300000,  'type': 'gneg'    },
      { 'id': 'p35.3',  'start': 27600001,  'end': 29900000,  'type': 'gpos25'  },
      { 'id': 'p36.11', 'start': 23600001,  'end': 27600000,  'type': 'gneg'    },
      { 'id': 'p36.12', 'start': 20100001,  'end': 23600000,  'type': 'gpos25'  },
      { 'id': 'p36.13', 'start': 15900001,  'end': 20100000,  'type': 'gneg'    },
      { 'id': 'p36.21', 'start': 12500001,  'end': 15900000,  'type': 'gpos50'  },
      { 'id': 'p36.22', 'start': 9100001,   'end': 12500000,  'type': 'gneg'    },
      { 'id': 'p36.23', 'start': 7100001,   'end': 9100000,   'type': 'gpos25'  },
      { 'id': 'p36.31', 'start': 5300001,   'end': 7100000,   'type': 'gneg'    },
      { 'id': 'p36.32', 'start': 2300001,   'end': 5300000,   'type': 'gpos25'  },
      { 'id': 'p36.33', 'start': 1,         'end': 2300000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 123400001, 'end': 125100000, 'type': 'acen'    },
      { 'id': 'q12',    'start': 125100001, 'end': 143200000, 'type': 'gvar'    },
      { 'id': 'q21.1',  'start': 143200001, 'end': 147500000, 'type': 'gneg'    },
      { 'id': 'q21.2',  'start': 147500001, 'end': 150600000, 'type': 'gpos50'  },
      { 'id': 'q21.3',  'start': 150600001, 'end': 155100000, 'type': 'gneg'    },
      { 'id': 'q22',    'start': 155100001, 'end': 156600000, 'type': 'gpos50'  },
      { 'id': 'q23.1',  'start': 156600001, 'end': 159100000, 'type': 'gneg'    },
      { 'id': 'q23.2',  'start': 159100001, 'end': 160500000, 'type': 'gpos50'  },
      { 'id': 'q23.3',  'start': 160500001, 'end': 165500000, 'type': 'gneg'    },
      { 'id': 'q24.1',  'start': 165500001, 'end': 167200000, 'type': 'gpos50'  },
      { 'id': 'q24.2',  'start': 167200001, 'end': 170900000, 'type': 'gneg'    },
      { 'id': 'q24.3',  'start': 170900001, 'end': 173000000, 'type': 'gpos75'  },
      { 'id': 'q25.1',  'start': 173000001, 'end': 176100000, 'type': 'gneg'    },
      { 'id': 'q25.2',  'start': 176100001, 'end': 180300000, 'type': 'gpos50'  },
      { 'id': 'q25.3',  'start': 180300001, 'end': 185800000, 'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 185800001, 'end': 190800000, 'type': 'gpos100' },
      { 'id': 'q31.2',  'start': 190800001, 'end': 193800000, 'type': 'gneg'    },
      { 'id': 'q31.3',  'start': 193800001, 'end': 198700000, 'type': 'gpos100' },
      { 'id': 'q32.1',  'start': 198700001, 'end': 207100000, 'type': 'gneg'    },
      { 'id': 'q32.2',  'start': 207100001, 'end': 211300000, 'type': 'gpos25'  },
      { 'id': 'q32.3',  'start': 211300001, 'end': 214400000, 'type': 'gneg'    },
      { 'id': 'q41',    'start': 214400001, 'end': 223900000, 'type': 'gpos100' },
      { 'id': 'q42.11', 'start': 223900001, 'end': 224400000, 'type': 'gneg'    },
      { 'id': 'q42.12', 'start': 224400001, 'end': 226800000, 'type': 'gpos25'  },
      { 'id': 'q42.13', 'start': 226800001, 'end': 230500000, 'type': 'gneg'    },
      { 'id': 'q42.2',  'start': 230500001, 'end': 234600000, 'type': 'gpos50'  },
      { 'id': 'q42.3',  'start': 234600001, 'end': 236400000, 'type': 'gneg'    },
      { 'id': 'q43',    'start': 236400001, 'end': 243500000, 'type': 'gpos75'  },
      { 'id': 'q44',    'start': 243500001, 'end': 248956422, 'type': 'gneg'    },
    ],
  },
  '2': {
    'size'  : 242193529,
    'bands' : [
      { 'id': 'p11.1', 'start': 91800001,  'end': 93900000,  'type': 'acen'    },
      { 'id': 'p11.2', 'start': 83100001,  'end': 91800000,  'type': 'gneg'    },
      { 'id': 'p12',   'start': 74800001,  'end': 83100000,  'type': 'gpos100' },
      { 'id': 'p13.1', 'start': 73300001,  'end': 74800000,  'type': 'gneg'    },
      { 'id': 'p13.2', 'start': 71300001,  'end': 73300000,  'type': 'gpos50'  },
      { 'id': 'p13.3', 'start': 68400001,  'end': 71300000,  'type': 'gneg'    },
      { 'id': 'p14',   'start': 63900001,  'end': 68400000,  'type': 'gpos50'  },
      { 'id': 'p15',   'start': 61000001,  'end': 63900000,  'type': 'gneg'    },
      { 'id': 'p16.1', 'start': 54700001,  'end': 61000000,  'type': 'gpos100' },
      { 'id': 'p16.2', 'start': 52600001,  'end': 54700000,  'type': 'gneg'    },
      { 'id': 'p16.3', 'start': 47500001,  'end': 52600000,  'type': 'gpos100' },
      { 'id': 'p21',   'start': 41500001,  'end': 47500000,  'type': 'gneg'    },
      { 'id': 'p22.1', 'start': 38300001,  'end': 41500000,  'type': 'gpos50'  },
      { 'id': 'p22.2', 'start': 36300001,  'end': 38300000,  'type': 'gneg'    },
      { 'id': 'p22.3', 'start': 31800001,  'end': 36300000,  'type': 'gpos75'  },
      { 'id': 'p23.1', 'start': 29800001,  'end': 31800000,  'type': 'gneg'    },
      { 'id': 'p23.2', 'start': 27700001,  'end': 29800000,  'type': 'gpos25'  },
      { 'id': 'p23.3', 'start': 23800001,  'end': 27700000,  'type': 'gneg'    },
      { 'id': 'p24.1', 'start': 19000001,  'end': 23800000,  'type': 'gpos75'  },
      { 'id': 'p24.2', 'start': 16500001,  'end': 19000000,  'type': 'gneg'    },
      { 'id': 'p24.3', 'start': 12000001,  'end': 16500000,  'type': 'gpos75'  },
      { 'id': 'p25.1', 'start': 6900001,   'end': 12000000,  'type': 'gneg'    },
      { 'id': 'p25.2', 'start': 4400001,   'end': 6900000,   'type': 'gpos50'  },
      { 'id': 'p25.3', 'start': 1,         'end': 4400000,   'type': 'gneg'    },
      { 'id': 'q11.1', 'start': 93900001,  'end': 96000000,  'type': 'acen'    },
      { 'id': 'q11.2', 'start': 96000001,  'end': 102100000, 'type': 'gneg'    },
      { 'id': 'q12.1', 'start': 102100001, 'end': 105300000, 'type': 'gpos50'  },
      { 'id': 'q12.2', 'start': 105300001, 'end': 106700000, 'type': 'gneg'    },
      { 'id': 'q12.3', 'start': 106700001, 'end': 108700000, 'type': 'gpos25'  },
      { 'id': 'q13',   'start': 108700001, 'end': 112200000, 'type': 'gneg'    },
      { 'id': 'q14.1', 'start': 112200001, 'end': 118100000, 'type': 'gpos50'  },
      { 'id': 'q14.2', 'start': 118100001, 'end': 121600000, 'type': 'gneg'    },
      { 'id': 'q14.3', 'start': 121600001, 'end': 129100000, 'type': 'gpos50'  },
      { 'id': 'q21.1', 'start': 129100001, 'end': 131700000, 'type': 'gneg'    },
      { 'id': 'q21.2', 'start': 131700001, 'end': 134300000, 'type': 'gpos25'  },
      { 'id': 'q21.3', 'start': 134300001, 'end': 136100000, 'type': 'gneg'    },
      { 'id': 'q22.1', 'start': 136100001, 'end': 141500000, 'type': 'gpos100' },
      { 'id': 'q22.2', 'start': 141500001, 'end': 143400000, 'type': 'gneg'    },
      { 'id': 'q22.3', 'start': 143400001, 'end': 147900000, 'type': 'gpos100' },
      { 'id': 'q23.1', 'start': 147900001, 'end': 149000000, 'type': 'gneg'    },
      { 'id': 'q23.2', 'start': 149000001, 'end': 149600000, 'type': 'gpos25'  },
      { 'id': 'q23.3', 'start': 149600001, 'end': 154000000, 'type': 'gneg'    },
      { 'id': 'q24.1', 'start': 154000001, 'end': 158900000, 'type': 'gpos75'  },
      { 'id': 'q24.2', 'start': 158900001, 'end': 162900000, 'type': 'gneg'    },
      { 'id': 'q24.3', 'start': 162900001, 'end': 168900000, 'type': 'gpos75'  },
      { 'id': 'q31.1', 'start': 168900001, 'end': 177100000, 'type': 'gneg'    },
      { 'id': 'q31.2', 'start': 177100001, 'end': 179700000, 'type': 'gpos50'  },
      { 'id': 'q31.3', 'start': 179700001, 'end': 182100000, 'type': 'gneg'    },
      { 'id': 'q32.1', 'start': 182100001, 'end': 188500000, 'type': 'gpos75'  },
      { 'id': 'q32.2', 'start': 188500001, 'end': 191100000, 'type': 'gneg'    },
      { 'id': 'q32.3', 'start': 191100001, 'end': 196600000, 'type': 'gpos75'  },
      { 'id': 'q33.1', 'start': 196600001, 'end': 202500000, 'type': 'gneg'    },
      { 'id': 'q33.2', 'start': 202500001, 'end': 204100000, 'type': 'gpos50'  },
      { 'id': 'q33.3', 'start': 204100001, 'end': 208200000, 'type': 'gneg'    },
      { 'id': 'q34',   'start': 208200001, 'end': 214500000, 'type': 'gpos100' },
      { 'id': 'q35',   'start': 214500001, 'end': 220700000, 'type': 'gneg'    },
      { 'id': 'q36.1', 'start': 220700001, 'end': 224300000, 'type': 'gpos75'  },
      { 'id': 'q36.2', 'start': 224300001, 'end': 225200000, 'type': 'gneg'    },
      { 'id': 'q36.3', 'start': 225200001, 'end': 230100000, 'type': 'gpos100' },
      { 'id': 'q37.1', 'start': 230100001, 'end': 234700000, 'type': 'gneg'    },
      { 'id': 'q37.2', 'start': 234700001, 'end': 236400000, 'type': 'gpos50'  },
      { 'id': 'q37.3', 'start': 236400001, 'end': 242193529, 'type': 'gneg'    },
    ],
  },
  '3': {
    'size'  : 198295559,
    'bands' : [
      { 'id': 'p11.1',  'start': 87800001,  'end': 90900000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 87100001,  'end': 87800000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 83500001,  'end': 87100000,  'type': 'gpos75'  },
      { 'id': 'p12.2',  'start': 79800001,  'end': 83500000,  'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 74100001,  'end': 79800000,  'type': 'gpos75'  },
      { 'id': 'p13',    'start': 69700001,  'end': 74100000,  'type': 'gneg'    },
      { 'id': 'p14.1',  'start': 63800001,  'end': 69700000,  'type': 'gpos50'  },
      { 'id': 'p14.2',  'start': 58600001,  'end': 63800000,  'type': 'gneg'    },
      { 'id': 'p14.3',  'start': 54400001,  'end': 58600000,  'type': 'gpos50'  },
      { 'id': 'p21.1',  'start': 52300001,  'end': 54400000,  'type': 'gneg'    },
      { 'id': 'p21.2',  'start': 50600001,  'end': 52300000,  'type': 'gpos25'  },
      { 'id': 'p21.31', 'start': 44200001,  'end': 50600000,  'type': 'gneg'    },
      { 'id': 'p21.32', 'start': 44100001,  'end': 44200000,  'type': 'gpos50'  },
      { 'id': 'p21.33', 'start': 43600001,  'end': 44100000,  'type': 'gneg'    },
      { 'id': 'p22.1',  'start': 39300001,  'end': 43600000,  'type': 'gpos75'  },
      { 'id': 'p22.2',  'start': 36400001,  'end': 39300000,  'type': 'gneg'    },
      { 'id': 'p22.3',  'start': 32000001,  'end': 36400000,  'type': 'gpos50'  },
      { 'id': 'p23',    'start': 30800001,  'end': 32000000,  'type': 'gneg'    },
      { 'id': 'p24.1',  'start': 26300001,  'end': 30800000,  'type': 'gpos75'  },
      { 'id': 'p24.2',  'start': 23800001,  'end': 26300000,  'type': 'gneg'    },
      { 'id': 'p24.3',  'start': 16300001,  'end': 23800000,  'type': 'gpos100' },
      { 'id': 'p25.1',  'start': 13200001,  'end': 16300000,  'type': 'gneg'    },
      { 'id': 'p25.2',  'start': 11600001,  'end': 13200000,  'type': 'gpos25'  },
      { 'id': 'p25.3',  'start': 8100001,   'end': 11600000,  'type': 'gneg'    },
      { 'id': 'p26.1',  'start': 4000001,   'end': 8100000,   'type': 'gpos50'  },
      { 'id': 'p26.2',  'start': 2800001,   'end': 4000000,   'type': 'gneg'    },
      { 'id': 'p26.3',  'start': 1,         'end': 2800000,   'type': 'gpos50'  },
      { 'id': 'q11.1',  'start': 90900001,  'end': 94000000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 94000001,  'end': 98600000,  'type': 'gvar'    },
      { 'id': 'q12.1',  'start': 98600001,  'end': 100300000, 'type': 'gneg'    },
      { 'id': 'q12.2',  'start': 100300001, 'end': 101200000, 'type': 'gpos25'  },
      { 'id': 'q12.3',  'start': 101200001, 'end': 103100000, 'type': 'gneg'    },
      { 'id': 'q13.11', 'start': 103100001, 'end': 106500000, 'type': 'gpos75'  },
      { 'id': 'q13.12', 'start': 106500001, 'end': 108200000, 'type': 'gneg'    },
      { 'id': 'q13.13', 'start': 108200001, 'end': 111600000, 'type': 'gpos50'  },
      { 'id': 'q13.2',  'start': 111600001, 'end': 113700000, 'type': 'gneg'    },
      { 'id': 'q13.31', 'start': 113700001, 'end': 117600000, 'type': 'gpos75'  },
      { 'id': 'q13.32', 'start': 117600001, 'end': 119300000, 'type': 'gneg'    },
      { 'id': 'q13.33', 'start': 119300001, 'end': 122200000, 'type': 'gpos75'  },
      { 'id': 'q21.1',  'start': 122200001, 'end': 124100000, 'type': 'gneg'    },
      { 'id': 'q21.2',  'start': 124100001, 'end': 126100000, 'type': 'gpos25'  },
      { 'id': 'q21.3',  'start': 126100001, 'end': 129500000, 'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 129500001, 'end': 134000000, 'type': 'gpos25'  },
      { 'id': 'q22.2',  'start': 134000001, 'end': 136000000, 'type': 'gneg'    },
      { 'id': 'q22.3',  'start': 136000001, 'end': 139000000, 'type': 'gpos25'  },
      { 'id': 'q23',    'start': 139000001, 'end': 143100000, 'type': 'gneg'    },
      { 'id': 'q24',    'start': 143100001, 'end': 149200000, 'type': 'gpos100' },
      { 'id': 'q25.1',  'start': 149200001, 'end': 152300000, 'type': 'gneg'    },
      { 'id': 'q25.2',  'start': 152300001, 'end': 155300000, 'type': 'gpos50'  },
      { 'id': 'q25.31', 'start': 155300001, 'end': 157300000, 'type': 'gneg'    },
      { 'id': 'q25.32', 'start': 157300001, 'end': 159300000, 'type': 'gpos50'  },
      { 'id': 'q25.33', 'start': 159300001, 'end': 161000000, 'type': 'gneg'    },
      { 'id': 'q26.1',  'start': 161000001, 'end': 167900000, 'type': 'gpos100' },
      { 'id': 'q26.2',  'start': 167900001, 'end': 171200000, 'type': 'gneg'    },
      { 'id': 'q26.31', 'start': 171200001, 'end': 176000000, 'type': 'gpos75'  },
      { 'id': 'q26.32', 'start': 176000001, 'end': 179300000, 'type': 'gneg'    },
      { 'id': 'q26.33', 'start': 179300001, 'end': 183000000, 'type': 'gpos75'  },
      { 'id': 'q27.1',  'start': 183000001, 'end': 184800000, 'type': 'gneg'    },
      { 'id': 'q27.2',  'start': 184800001, 'end': 186300000, 'type': 'gpos25'  },
      { 'id': 'q27.3',  'start': 186300001, 'end': 188200000, 'type': 'gneg'    },
      { 'id': 'q28',    'start': 188200001, 'end': 192600000, 'type': 'gpos75'  },
      { 'id': 'q29',    'start': 192600001, 'end': 198295559, 'type': 'gneg'    },
    ],
  },
  '4': {
    'size'  : 190214555,
    'bands' : [
      { 'id': 'p11',    'start': 48200001,  'end': 50000000,  'type': 'acen'    },
      { 'id': 'p12',    'start': 44600001,  'end': 48200000,  'type': 'gneg'    },
      { 'id': 'p13',    'start': 41200001,  'end': 44600000,  'type': 'gpos50'  },
      { 'id': 'p14',    'start': 35800001,  'end': 41200000,  'type': 'gneg'    },
      { 'id': 'p15.1',  'start': 27700001,  'end': 35800000,  'type': 'gpos100' },
      { 'id': 'p15.2',  'start': 21300001,  'end': 27700000,  'type': 'gneg'    },
      { 'id': 'p15.31', 'start': 17700001,  'end': 21300000,  'type': 'gpos75'  },
      { 'id': 'p15.32', 'start': 15000001,  'end': 17700000,  'type': 'gneg'    },
      { 'id': 'p15.33', 'start': 11300001,  'end': 15000000,  'type': 'gpos50'  },
      { 'id': 'p16.1',  'start': 6000001,   'end': 11300000,  'type': 'gneg'    },
      { 'id': 'p16.2',  'start': 4500001,   'end': 6000000,   'type': 'gpos25'  },
      { 'id': 'p16.3',  'start': 1,         'end': 4500000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 50000001,  'end': 51800000,  'type': 'acen'    },
      { 'id': 'q12',    'start': 51800001,  'end': 58500000,  'type': 'gneg'    },
      { 'id': 'q13.1',  'start': 58500001,  'end': 65500000,  'type': 'gpos100' },
      { 'id': 'q13.2',  'start': 65500001,  'end': 69400000,  'type': 'gneg'    },
      { 'id': 'q13.3',  'start': 69400001,  'end': 75300000,  'type': 'gpos75'  },
      { 'id': 'q21.1',  'start': 75300001,  'end': 78000000,  'type': 'gneg'    },
      { 'id': 'q21.21', 'start': 78000001,  'end': 81500000,  'type': 'gpos50'  },
      { 'id': 'q21.22', 'start': 81500001,  'end': 83200000,  'type': 'gneg'    },
      { 'id': 'q21.23', 'start': 83200001,  'end': 86000000,  'type': 'gpos25'  },
      { 'id': 'q21.3',  'start': 86000001,  'end': 87100000,  'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 87100001,  'end': 92800000,  'type': 'gpos75'  },
      { 'id': 'q22.2',  'start': 92800001,  'end': 94200000,  'type': 'gneg'    },
      { 'id': 'q22.3',  'start': 94200001,  'end': 97900000,  'type': 'gpos75'  },
      { 'id': 'q23',    'start': 97900001,  'end': 100100000, 'type': 'gneg'    },
      { 'id': 'q24',    'start': 100100001, 'end': 106700000, 'type': 'gpos50'  },
      { 'id': 'q25',    'start': 106700001, 'end': 113200000, 'type': 'gneg'    },
      { 'id': 'q26',    'start': 113200001, 'end': 119900000, 'type': 'gpos75'  },
      { 'id': 'q27',    'start': 119900001, 'end': 122800000, 'type': 'gneg'    },
      { 'id': 'q28.1',  'start': 122800001, 'end': 127900000, 'type': 'gpos50'  },
      { 'id': 'q28.2',  'start': 127900001, 'end': 130100000, 'type': 'gneg'    },
      { 'id': 'q28.3',  'start': 130100001, 'end': 138500000, 'type': 'gpos100' },
      { 'id': 'q31.1',  'start': 138500001, 'end': 140600000, 'type': 'gneg'    },
      { 'id': 'q31.21', 'start': 140600001, 'end': 145900000, 'type': 'gpos25'  },
      { 'id': 'q31.22', 'start': 145900001, 'end': 147500000, 'type': 'gneg'    },
      { 'id': 'q31.23', 'start': 147500001, 'end': 150200000, 'type': 'gpos25'  },
      { 'id': 'q31.3',  'start': 150200001, 'end': 154600000, 'type': 'gneg'    },
      { 'id': 'q32.1',  'start': 154600001, 'end': 160800000, 'type': 'gpos100' },
      { 'id': 'q32.2',  'start': 160800001, 'end': 163600000, 'type': 'gneg'    },
      { 'id': 'q32.3',  'start': 163600001, 'end': 169200000, 'type': 'gpos100' },
      { 'id': 'q33',    'start': 169200001, 'end': 171000000, 'type': 'gneg'    },
      { 'id': 'q34.1',  'start': 171000001, 'end': 175400000, 'type': 'gpos75'  },
      { 'id': 'q34.2',  'start': 175400001, 'end': 176600000, 'type': 'gneg'    },
      { 'id': 'q34.3',  'start': 176600001, 'end': 182300000, 'type': 'gpos100' },
      { 'id': 'q35.1',  'start': 182300001, 'end': 186200000, 'type': 'gneg'    },
      { 'id': 'q35.2',  'start': 186200001, 'end': 190214555, 'type': 'gpos25'  },
    ],
  },
  '5': {
    'size'  : 181538259,
    'bands' : [
      { 'id': 'p11',    'start': 46100001,  'end': 48800000,  'type': 'acen'    },
      { 'id': 'p12',    'start': 42500001,  'end': 46100000,  'type': 'gpos50'  },
      { 'id': 'p13.1',  'start': 38400001,  'end': 42500000,  'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 33800001,  'end': 38400000,  'type': 'gpos25'  },
      { 'id': 'p13.3',  'start': 28900001,  'end': 33800000,  'type': 'gneg'    },
      { 'id': 'p14.1',  'start': 24600001,  'end': 28900000,  'type': 'gpos100' },
      { 'id': 'p14.2',  'start': 23300001,  'end': 24600000,  'type': 'gneg'    },
      { 'id': 'p14.3',  'start': 18400001,  'end': 23300000,  'type': 'gpos100' },
      { 'id': 'p15.1',  'start': 15000001,  'end': 18400000,  'type': 'gneg'    },
      { 'id': 'p15.2',  'start': 9900001,   'end': 15000000,  'type': 'gpos50'  },
      { 'id': 'p15.31', 'start': 6300001,   'end': 9900000,   'type': 'gneg'    },
      { 'id': 'p15.32', 'start': 4400001,   'end': 6300000,   'type': 'gpos25'  },
      { 'id': 'p15.33', 'start': 1,         'end': 4400000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 48800001,  'end': 51400000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 51400001,  'end': 59600000,  'type': 'gneg'    },
      { 'id': 'q12.1',  'start': 59600001,  'end': 63600000,  'type': 'gpos75'  },
      { 'id': 'q12.2',  'start': 63600001,  'end': 63900000,  'type': 'gneg'    },
      { 'id': 'q12.3',  'start': 63900001,  'end': 67400000,  'type': 'gpos75'  },
      { 'id': 'q13.1',  'start': 67400001,  'end': 69100000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 69100001,  'end': 74000000,  'type': 'gpos50'  },
      { 'id': 'q13.3',  'start': 74000001,  'end': 77600000,  'type': 'gneg'    },
      { 'id': 'q14.1',  'start': 77600001,  'end': 82100000,  'type': 'gpos50'  },
      { 'id': 'q14.2',  'start': 82100001,  'end': 83500000,  'type': 'gneg'    },
      { 'id': 'q14.3',  'start': 83500001,  'end': 93000000,  'type': 'gpos100' },
      { 'id': 'q15',    'start': 93000001,  'end': 98900000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 98900001,  'end': 103400000, 'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 103400001, 'end': 105100000, 'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 105100001, 'end': 110200000, 'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 110200001, 'end': 112200000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 112200001, 'end': 113800000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 113800001, 'end': 115900000, 'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 115900001, 'end': 122100000, 'type': 'gpos100' },
      { 'id': 'q23.2',  'start': 122100001, 'end': 127900000, 'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 127900001, 'end': 131200000, 'type': 'gpos100' },
      { 'id': 'q31.1',  'start': 131200001, 'end': 136900000, 'type': 'gneg'    },
      { 'id': 'q31.2',  'start': 136900001, 'end': 140100000, 'type': 'gpos25'  },
      { 'id': 'q31.3',  'start': 140100001, 'end': 145100000, 'type': 'gneg'    },
      { 'id': 'q32',    'start': 145100001, 'end': 150400000, 'type': 'gpos75'  },
      { 'id': 'q33.1',  'start': 150400001, 'end': 153300000, 'type': 'gneg'    },
      { 'id': 'q33.2',  'start': 153300001, 'end': 156300000, 'type': 'gpos50'  },
      { 'id': 'q33.3',  'start': 156300001, 'end': 160500000, 'type': 'gneg'    },
      { 'id': 'q34',    'start': 160500001, 'end': 169000000, 'type': 'gpos100' },
      { 'id': 'q35.1',  'start': 169000001, 'end': 173300000, 'type': 'gneg'    },
      { 'id': 'q35.2',  'start': 173300001, 'end': 177100000, 'type': 'gpos25'  },
      { 'id': 'q35.3',  'start': 177100001, 'end': 181538259, 'type': 'gneg'    },
    ],
  },
  '6': {
    'size'  : 170805979,
    'bands' : [
      { 'id': 'p11.1',  'start': 58500001,  'end': 59800000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 57200001,  'end': 58500000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 53000001,  'end': 57200000,  'type': 'gpos100' },
      { 'id': 'p12.2',  'start': 51800001,  'end': 53000000,  'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 46200001,  'end': 51800000,  'type': 'gpos100' },
      { 'id': 'p21.1',  'start': 40500001,  'end': 46200000,  'type': 'gneg'    },
      { 'id': 'p21.2',  'start': 36600001,  'end': 40500000,  'type': 'gpos25'  },
      { 'id': 'p21.31', 'start': 33500001,  'end': 36600000,  'type': 'gneg'    },
      { 'id': 'p21.32', 'start': 32100001,  'end': 33500000,  'type': 'gpos25'  },
      { 'id': 'p21.33', 'start': 30500001,  'end': 32100000,  'type': 'gneg'    },
      { 'id': 'p22.1',  'start': 27100001,  'end': 30500000,  'type': 'gpos50'  },
      { 'id': 'p22.2',  'start': 25200001,  'end': 27100000,  'type': 'gneg'    },
      { 'id': 'p22.3',  'start': 15200001,  'end': 25200000,  'type': 'gpos75'  },
      { 'id': 'p23',    'start': 13400001,  'end': 15200000,  'type': 'gneg'    },
      { 'id': 'p24.1',  'start': 11600001,  'end': 13400000,  'type': 'gpos25'  },
      { 'id': 'p24.2',  'start': 10600001,  'end': 11600000,  'type': 'gneg'    },
      { 'id': 'p24.3',  'start': 7100001,   'end': 10600000,  'type': 'gpos50'  },
      { 'id': 'p25.1',  'start': 4200001,   'end': 7100000,   'type': 'gneg'    },
      { 'id': 'p25.2',  'start': 2300001,   'end': 4200000,   'type': 'gpos25'  },
      { 'id': 'p25.3',  'start': 1,         'end': 2300000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 59800001,  'end': 62600000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 62600001,  'end': 62700000,  'type': 'gneg'    },
      { 'id': 'q12',    'start': 62700001,  'end': 69200000,  'type': 'gpos100' },
      { 'id': 'q13',    'start': 69200001,  'end': 75200000,  'type': 'gneg'    },
      { 'id': 'q14.1',  'start': 75200001,  'end': 83200000,  'type': 'gpos50'  },
      { 'id': 'q14.2',  'start': 83200001,  'end': 84200000,  'type': 'gneg'    },
      { 'id': 'q14.3',  'start': 84200001,  'end': 87300000,  'type': 'gpos50'  },
      { 'id': 'q15',    'start': 87300001,  'end': 92500000,  'type': 'gneg'    },
      { 'id': 'q16.1',  'start': 92500001,  'end': 98900000,  'type': 'gpos100' },
      { 'id': 'q16.2',  'start': 98900001,  'end': 100000000, 'type': 'gneg'    },
      { 'id': 'q16.3',  'start': 100000001, 'end': 105000000, 'type': 'gpos100' },
      { 'id': 'q21',    'start': 105000001, 'end': 114200000, 'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 114200001, 'end': 117900000, 'type': 'gpos75'  },
      { 'id': 'q22.2',  'start': 117900001, 'end': 118100000, 'type': 'gneg'    },
      { 'id': 'q22.31', 'start': 118100001, 'end': 125800000, 'type': 'gpos100' },
      { 'id': 'q22.32', 'start': 125800001, 'end': 126800000, 'type': 'gneg'    },
      { 'id': 'q22.33', 'start': 126800001, 'end': 130000000, 'type': 'gpos75'  },
      { 'id': 'q23.1',  'start': 130000001, 'end': 130900000, 'type': 'gneg'    },
      { 'id': 'q23.2',  'start': 130900001, 'end': 134700000, 'type': 'gpos50'  },
      { 'id': 'q23.3',  'start': 134700001, 'end': 138300000, 'type': 'gneg'    },
      { 'id': 'q24.1',  'start': 138300001, 'end': 142200000, 'type': 'gpos75'  },
      { 'id': 'q24.2',  'start': 142200001, 'end': 145100000, 'type': 'gneg'    },
      { 'id': 'q24.3',  'start': 145100001, 'end': 148500000, 'type': 'gpos75'  },
      { 'id': 'q25.1',  'start': 148500001, 'end': 152100000, 'type': 'gneg'    },
      { 'id': 'q25.2',  'start': 152100001, 'end': 155200000, 'type': 'gpos50'  },
      { 'id': 'q25.3',  'start': 155200001, 'end': 160600000, 'type': 'gneg'    },
      { 'id': 'q26',    'start': 160600001, 'end': 164100000, 'type': 'gpos50'  },
      { 'id': 'q27',    'start': 164100001, 'end': 170805979, 'type': 'gneg'    },
    ],
  },
  '7': {
    'size'  : 159345973,
    'bands' : [
      { 'id': 'p11.1',  'start': 58100001,  'end': 60100000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 53900001,  'end': 58100000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 50500001,  'end': 53900000,  'type': 'gpos75'  },
      { 'id': 'p12.2',  'start': 49000001,  'end': 50500000,  'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 45400001,  'end': 49000000,  'type': 'gpos75'  },
      { 'id': 'p13',    'start': 43300001,  'end': 45400000,  'type': 'gneg'    },
      { 'id': 'p14.1',  'start': 37100001,  'end': 43300000,  'type': 'gpos75'  },
      { 'id': 'p14.2',  'start': 34900001,  'end': 37100000,  'type': 'gneg'    },
      { 'id': 'p14.3',  'start': 28800001,  'end': 34900000,  'type': 'gpos75'  },
      { 'id': 'p15.1',  'start': 27900001,  'end': 28800000,  'type': 'gneg'    },
      { 'id': 'p15.2',  'start': 25500001,  'end': 27900000,  'type': 'gpos50'  },
      { 'id': 'p15.3',  'start': 20900001,  'end': 25500000,  'type': 'gneg'    },
      { 'id': 'p21.1',  'start': 16500001,  'end': 20900000,  'type': 'gpos100' },
      { 'id': 'p21.2',  'start': 13700001,  'end': 16500000,  'type': 'gneg'    },
      { 'id': 'p21.3',  'start': 7200001,   'end': 13700000,  'type': 'gpos100' },
      { 'id': 'p22.1',  'start': 4500001,   'end': 7200000,   'type': 'gneg'    },
      { 'id': 'p22.2',  'start': 2800001,   'end': 4500000,   'type': 'gpos25'  },
      { 'id': 'p22.3',  'start': 1,         'end': 2800000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 60100001,  'end': 62100000,  'type': 'acen'    },
      { 'id': 'q11.21', 'start': 62100001,  'end': 67500000,  'type': 'gneg'    },
      { 'id': 'q11.22', 'start': 67500001,  'end': 72700000,  'type': 'gpos50'  },
      { 'id': 'q11.23', 'start': 72700001,  'end': 77900000,  'type': 'gneg'    },
      { 'id': 'q21.11', 'start': 77900001,  'end': 86700000,  'type': 'gpos100' },
      { 'id': 'q21.12', 'start': 86700001,  'end': 88500000,  'type': 'gneg'    },
      { 'id': 'q21.13', 'start': 88500001,  'end': 91500000,  'type': 'gpos75'  },
      { 'id': 'q21.2',  'start': 91500001,  'end': 93300000,  'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 93300001,  'end': 98400000,  'type': 'gpos75'  },
      { 'id': 'q22.1',  'start': 98400001,  'end': 104200000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 104200001, 'end': 104900000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 104900001, 'end': 107800000, 'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 107800001, 'end': 115000000, 'type': 'gpos75'  },
      { 'id': 'q31.2',  'start': 115000001, 'end': 117700000, 'type': 'gneg'    },
      { 'id': 'q31.31', 'start': 117700001, 'end': 121400000, 'type': 'gpos75'  },
      { 'id': 'q31.32', 'start': 121400001, 'end': 124100000, 'type': 'gneg'    },
      { 'id': 'q31.33', 'start': 124100001, 'end': 127500000, 'type': 'gpos75'  },
      { 'id': 'q32.1',  'start': 127500001, 'end': 129600000, 'type': 'gneg'    },
      { 'id': 'q32.2',  'start': 129600001, 'end': 130800000, 'type': 'gpos25'  },
      { 'id': 'q32.3',  'start': 130800001, 'end': 132900000, 'type': 'gneg'    },
      { 'id': 'q33',    'start': 132900001, 'end': 138500000, 'type': 'gpos50'  },
      { 'id': 'q34',    'start': 138500001, 'end': 143400000, 'type': 'gneg'    },
      { 'id': 'q35',    'start': 143400001, 'end': 148200000, 'type': 'gpos75'  },
      { 'id': 'q36.1',  'start': 148200001, 'end': 152800000, 'type': 'gneg'    },
      { 'id': 'q36.2',  'start': 152800001, 'end': 155200000, 'type': 'gpos25'  },
      { 'id': 'q36.3',  'start': 155200001, 'end': 159345973, 'type': 'gneg'    },
    ],
  },
  '8': {
    'size'  : 145138636,
    'bands' : [
      { 'id': 'p11.1',  'start': 43200001,  'end': 45200000,  'type': 'acen'    },
      { 'id': 'p11.21', 'start': 39900001,  'end': 43200000,  'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 38500001,  'end': 39900000,  'type': 'gpos25'  },
      { 'id': 'p11.23', 'start': 36700001,  'end': 38500000,  'type': 'gneg'    },
      { 'id': 'p12',    'start': 29000001,  'end': 36700000,  'type': 'gpos75'  },
      { 'id': 'p21.1',  'start': 27500001,  'end': 29000000,  'type': 'gneg'    },
      { 'id': 'p21.2',  'start': 23500001,  'end': 27500000,  'type': 'gpos50'  },
      { 'id': 'p21.3',  'start': 19200001,  'end': 23500000,  'type': 'gneg'    },
      { 'id': 'p22',    'start': 12800001,  'end': 19200000,  'type': 'gpos100' },
      { 'id': 'p23.1',  'start': 6300001,   'end': 12800000,  'type': 'gneg'    },
      { 'id': 'p23.2',  'start': 2300001,   'end': 6300000,   'type': 'gpos75'  },
      { 'id': 'p23.3',  'start': 1,         'end': 2300000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 45200001,  'end': 47200000,  'type': 'acen'    },
      { 'id': 'q11.21', 'start': 47200001,  'end': 51300000,  'type': 'gneg'    },
      { 'id': 'q11.22', 'start': 51300001,  'end': 51700000,  'type': 'gpos75'  },
      { 'id': 'q11.23', 'start': 51700001,  'end': 54600000,  'type': 'gneg'    },
      { 'id': 'q12.1',  'start': 54600001,  'end': 60600000,  'type': 'gpos50'  },
      { 'id': 'q12.2',  'start': 60600001,  'end': 61300000,  'type': 'gneg'    },
      { 'id': 'q12.3',  'start': 61300001,  'end': 65100000,  'type': 'gpos50'  },
      { 'id': 'q13.1',  'start': 65100001,  'end': 67100000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 67100001,  'end': 69600000,  'type': 'gpos50'  },
      { 'id': 'q13.3',  'start': 69600001,  'end': 72000000,  'type': 'gneg'    },
      { 'id': 'q21.11', 'start': 72000001,  'end': 74600000,  'type': 'gpos100' },
      { 'id': 'q21.12', 'start': 74600001,  'end': 74700000,  'type': 'gneg'    },
      { 'id': 'q21.13', 'start': 74700001,  'end': 83500000,  'type': 'gpos75'  },
      { 'id': 'q21.2',  'start': 83500001,  'end': 85900000,  'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 85900001,  'end': 92300000,  'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 92300001,  'end': 97900000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 97900001,  'end': 100500000, 'type': 'gpos25'  },
      { 'id': 'q22.3',  'start': 100500001, 'end': 105100000, 'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 105100001, 'end': 109500000, 'type': 'gpos75'  },
      { 'id': 'q23.2',  'start': 109500001, 'end': 111100000, 'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 111100001, 'end': 116700000, 'type': 'gpos100' },
      { 'id': 'q24.11', 'start': 116700001, 'end': 118300000, 'type': 'gneg'    },
      { 'id': 'q24.12', 'start': 118300001, 'end': 121500000, 'type': 'gpos50'  },
      { 'id': 'q24.13', 'start': 121500001, 'end': 126300000, 'type': 'gneg'    },
      { 'id': 'q24.21', 'start': 126300001, 'end': 130400000, 'type': 'gpos50'  },
      { 'id': 'q24.22', 'start': 130400001, 'end': 135400000, 'type': 'gneg'    },
      { 'id': 'q24.23', 'start': 135400001, 'end': 138900000, 'type': 'gpos75'  },
      { 'id': 'q24.3',  'start': 138900001, 'end': 145138636, 'type': 'gneg'    },
    ],
  },
  '9': {
    'size'  : 138394717,
    'bands' : [
      { 'id': 'p11.1',  'start': 42200001,  'end': 43000000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 40000001,  'end': 42200000,  'type': 'gneg'    },
      { 'id': 'p12',    'start': 39000001,  'end': 40000000,  'type': 'gpos50'  },
      { 'id': 'p13.1',  'start': 37900001,  'end': 39000000,  'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 36300001,  'end': 37900000,  'type': 'gpos25'  },
      { 'id': 'p13.3',  'start': 33200001,  'end': 36300000,  'type': 'gneg'    },
      { 'id': 'p21.1',  'start': 28000001,  'end': 33200000,  'type': 'gpos100' },
      { 'id': 'p21.2',  'start': 25600001,  'end': 28000000,  'type': 'gneg'    },
      { 'id': 'p21.3',  'start': 19900001,  'end': 25600000,  'type': 'gpos100' },
      { 'id': 'p22.1',  'start': 18500001,  'end': 19900000,  'type': 'gneg'    },
      { 'id': 'p22.2',  'start': 16600001,  'end': 18500000,  'type': 'gpos25'  },
      { 'id': 'p22.3',  'start': 14200001,  'end': 16600000,  'type': 'gneg'    },
      { 'id': 'p23',    'start': 9000001,   'end': 14200000,  'type': 'gpos75'  },
      { 'id': 'p24.1',  'start': 4600001,   'end': 9000000,   'type': 'gneg'    },
      { 'id': 'p24.2',  'start': 2200001,   'end': 4600000,   'type': 'gpos25'  },
      { 'id': 'p24.3',  'start': 1,         'end': 2200000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 43000001,  'end': 45500000,  'type': 'acen'    },
      { 'id': 'q12',    'start': 45500001,  'end': 61500000,  'type': 'gvar'    },
      { 'id': 'q13',    'start': 61500001,  'end': 65000000,  'type': 'gneg'    },
      { 'id': 'q21.11', 'start': 65000001,  'end': 69300000,  'type': 'gpos25'  },
      { 'id': 'q21.12', 'start': 69300001,  'end': 71300000,  'type': 'gneg'    },
      { 'id': 'q21.13', 'start': 71300001,  'end': 76600000,  'type': 'gpos50'  },
      { 'id': 'q21.2',  'start': 76600001,  'end': 78500000,  'type': 'gneg'    },
      { 'id': 'q21.31', 'start': 78500001,  'end': 81500000,  'type': 'gpos50'  },
      { 'id': 'q21.32', 'start': 81500001,  'end': 84300000,  'type': 'gneg'    },
      { 'id': 'q21.33', 'start': 84300001,  'end': 87800000,  'type': 'gpos50'  },
      { 'id': 'q22.1',  'start': 87800001,  'end': 89200000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 89200001,  'end': 91200000,  'type': 'gpos25'  },
      { 'id': 'q22.31', 'start': 91200001,  'end': 93900000,  'type': 'gneg'    },
      { 'id': 'q22.32', 'start': 93900001,  'end': 96500000,  'type': 'gpos25'  },
      { 'id': 'q22.33', 'start': 96500001,  'end': 99800000,  'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 99800001,  'end': 105400000, 'type': 'gpos100' },
      { 'id': 'q31.2',  'start': 105400001, 'end': 108500000, 'type': 'gneg'    },
      { 'id': 'q31.3',  'start': 108500001, 'end': 112100000, 'type': 'gpos25'  },
      { 'id': 'q32',    'start': 112100001, 'end': 114900000, 'type': 'gneg'    },
      { 'id': 'q33.1',  'start': 114900001, 'end': 119800000, 'type': 'gpos75'  },
      { 'id': 'q33.2',  'start': 119800001, 'end': 123100000, 'type': 'gneg'    },
      { 'id': 'q33.3',  'start': 123100001, 'end': 127500000, 'type': 'gpos25'  },
      { 'id': 'q34.11', 'start': 127500001, 'end': 130600000, 'type': 'gneg'    },
      { 'id': 'q34.12', 'start': 130600001, 'end': 131100000, 'type': 'gpos25'  },
      { 'id': 'q34.13', 'start': 131100001, 'end': 133100000, 'type': 'gneg'    },
      { 'id': 'q34.2',  'start': 133100001, 'end': 134500000, 'type': 'gpos25'  },
      { 'id': 'q34.3',  'start': 134500001, 'end': 138394717, 'type': 'gneg'    },
    ],
  },
  '10': {
    'size'  : 133797422,
    'bands' : [
      { 'id': 'p11.1',  'start': 38000001,  'end': 39800000,  'type': 'acen'    },
      { 'id': 'p11.21', 'start': 34200001,  'end': 38000000,  'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 31100001,  'end': 34200000,  'type': 'gpos25'  },
      { 'id': 'p11.23', 'start': 29300001,  'end': 31100000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 24300001,  'end': 29300000,  'type': 'gpos50'  },
      { 'id': 'p12.2',  'start': 22300001,  'end': 24300000,  'type': 'gneg'    },
      { 'id': 'p12.31', 'start': 18400001,  'end': 22300000,  'type': 'gpos75'  },
      { 'id': 'p12.32', 'start': 18300001,  'end': 18400000,  'type': 'gneg'    },
      { 'id': 'p12.33', 'start': 17300001,  'end': 18300000,  'type': 'gpos75'  },
      { 'id': 'p13',    'start': 12200001,  'end': 17300000,  'type': 'gneg'    },
      { 'id': 'p14',    'start': 6600001,   'end': 12200000,  'type': 'gpos75'  },
      { 'id': 'p15.1',  'start': 3800001,   'end': 6600000,   'type': 'gneg'    },
      { 'id': 'p15.2',  'start': 3000001,   'end': 3800000,   'type': 'gpos25'  },
      { 'id': 'p15.3',  'start': 1,         'end': 3000000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 39800001,  'end': 41600000,  'type': 'acen'    },
      { 'id': 'q11.21', 'start': 41600001,  'end': 45500000,  'type': 'gneg'    },
      { 'id': 'q11.22', 'start': 45500001,  'end': 48600000,  'type': 'gpos25'  },
      { 'id': 'q11.23', 'start': 48600001,  'end': 51100000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 51100001,  'end': 59400000,  'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 59400001,  'end': 62800000,  'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 62800001,  'end': 68800000,  'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 68800001,  'end': 73100000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 73100001,  'end': 75900000,  'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 75900001,  'end': 80300000,  'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 80300001,  'end': 86100000,  'type': 'gpos100' },
      { 'id': 'q23.2',  'start': 86100001,  'end': 87700000,  'type': 'gneg'    },
      { 'id': 'q23.31', 'start': 87700001,  'end': 91100000,  'type': 'gpos75'  },
      { 'id': 'q23.32', 'start': 91100001,  'end': 92300000,  'type': 'gneg'    },
      { 'id': 'q23.33', 'start': 92300001,  'end': 95300000,  'type': 'gpos50'  },
      { 'id': 'q24.1',  'start': 95300001,  'end': 97500000,  'type': 'gneg'    },
      { 'id': 'q24.2',  'start': 97500001,  'end': 100100000, 'type': 'gpos50'  },
      { 'id': 'q24.31', 'start': 100100001, 'end': 101200000, 'type': 'gneg'    },
      { 'id': 'q24.32', 'start': 101200001, 'end': 103100000, 'type': 'gpos25'  },
      { 'id': 'q24.33', 'start': 103100001, 'end': 104000000, 'type': 'gneg'    },
      { 'id': 'q25.1',  'start': 104000001, 'end': 110100000, 'type': 'gpos100' },
      { 'id': 'q25.2',  'start': 110100001, 'end': 113100000, 'type': 'gneg'    },
      { 'id': 'q25.3',  'start': 113100001, 'end': 117300000, 'type': 'gpos75'  },
      { 'id': 'q26.11', 'start': 117300001, 'end': 119900000, 'type': 'gneg'    },
      { 'id': 'q26.12', 'start': 119900001, 'end': 121400000, 'type': 'gpos50'  },
      { 'id': 'q26.13', 'start': 121400001, 'end': 125700000, 'type': 'gneg'    },
      { 'id': 'q26.2',  'start': 125700001, 'end': 128800000, 'type': 'gpos50'  },
      { 'id': 'q26.3',  'start': 128800001, 'end': 133797422, 'type': 'gneg'    },
    ],
  },
  '11': {
    'size'  : 135086622,
    'bands' : [
      { 'id': 'p11.11', 'start': 51000001,  'end': 53400000,  'type': 'acen'    },
      { 'id': 'p11.12', 'start': 48800001,  'end': 51000000,  'type': 'gpos75'  },
      { 'id': 'p11.2',  'start': 43400001,  'end': 48800000,  'type': 'gneg'    },
      { 'id': 'p12',    'start': 36400001,  'end': 43400000,  'type': 'gpos100' },
      { 'id': 'p13',    'start': 31000001,  'end': 36400000,  'type': 'gneg'    },
      { 'id': 'p14.1',  'start': 27200001,  'end': 31000000,  'type': 'gpos75'  },
      { 'id': 'p14.2',  'start': 26200001,  'end': 27200000,  'type': 'gneg'    },
      { 'id': 'p14.3',  'start': 22000001,  'end': 26200000,  'type': 'gpos100' },
      { 'id': 'p15.1',  'start': 16900001,  'end': 22000000,  'type': 'gneg'    },
      { 'id': 'p15.2',  'start': 13800001,  'end': 16900000,  'type': 'gpos50'  },
      { 'id': 'p15.3',  'start': 11700001,  'end': 13800000,  'type': 'gneg'    },
      { 'id': 'p15.4',  'start': 2800001,   'end': 11700000,  'type': 'gpos50'  },
      { 'id': 'p15.5',  'start': 1,         'end': 2800000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 53400001,  'end': 55800000,  'type': 'acen'    },
      { 'id': 'q12.1',  'start': 55800001,  'end': 60100000,  'type': 'gpos75'  },
      { 'id': 'q12.2',  'start': 60100001,  'end': 61900000,  'type': 'gneg'    },
      { 'id': 'q12.3',  'start': 61900001,  'end': 63600000,  'type': 'gpos25'  },
      { 'id': 'q13.1',  'start': 63600001,  'end': 66100000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 66100001,  'end': 68700000,  'type': 'gpos25'  },
      { 'id': 'q13.3',  'start': 68700001,  'end': 70500000,  'type': 'gneg'    },
      { 'id': 'q13.4',  'start': 70500001,  'end': 75500000,  'type': 'gpos50'  },
      { 'id': 'q13.5',  'start': 75500001,  'end': 77400000,  'type': 'gneg'    },
      { 'id': 'q14.1',  'start': 77400001,  'end': 85900000,  'type': 'gpos100' },
      { 'id': 'q14.2',  'start': 85900001,  'end': 88600000,  'type': 'gneg'    },
      { 'id': 'q14.3',  'start': 88600001,  'end': 93000000,  'type': 'gpos100' },
      { 'id': 'q21',    'start': 93000001,  'end': 97400000,  'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 97400001,  'end': 102300000, 'type': 'gpos100' },
      { 'id': 'q22.2',  'start': 102300001, 'end': 103000000, 'type': 'gneg'    },
      { 'id': 'q22.3',  'start': 103000001, 'end': 110600000, 'type': 'gpos100' },
      { 'id': 'q23.1',  'start': 110600001, 'end': 112700000, 'type': 'gneg'    },
      { 'id': 'q23.2',  'start': 112700001, 'end': 114600000, 'type': 'gpos50'  },
      { 'id': 'q23.3',  'start': 114600001, 'end': 121300000, 'type': 'gneg'    },
      { 'id': 'q24.1',  'start': 121300001, 'end': 124000000, 'type': 'gpos50'  },
      { 'id': 'q24.2',  'start': 124000001, 'end': 127900000, 'type': 'gneg'    },
      { 'id': 'q24.3',  'start': 127900001, 'end': 130900000, 'type': 'gpos50'  },
      { 'id': 'q25',    'start': 130900001, 'end': 135086622, 'type': 'gneg'    },
    ],
  },
  '12': {
    'size'  : 133275309,
    'bands' : [
      { 'id': 'p11.1',  'start': 33200001,  'end': 35500000,  'type': 'acen'    },
      { 'id': 'p11.21', 'start': 30500001,  'end': 33200000,  'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 27600001,  'end': 30500000,  'type': 'gpos50'  },
      { 'id': 'p11.23', 'start': 26300001,  'end': 27600000,  'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 21100001,  'end': 26300000,  'type': 'gpos100' },
      { 'id': 'p12.2',  'start': 19800001,  'end': 21100000,  'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 14600001,  'end': 19800000,  'type': 'gpos100' },
      { 'id': 'p13.1',  'start': 12600001,  'end': 14600000,  'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 10000001,  'end': 12600000,  'type': 'gpos75'  },
      { 'id': 'p13.31', 'start': 5300001,   'end': 10000000,  'type': 'gneg'    },
      { 'id': 'p13.32', 'start': 3200001,   'end': 5300000,   'type': 'gpos25'  },
      { 'id': 'p13.33', 'start': 1,         'end': 3200000,   'type': 'gneg'    },
      { 'id': 'q11',    'start': 35500001,  'end': 37800000,  'type': 'acen'    },
      { 'id': 'q12',    'start': 37800001,  'end': 46000000,  'type': 'gpos100' },
      { 'id': 'q13.11', 'start': 46000001,  'end': 48700000,  'type': 'gneg'    },
      { 'id': 'q13.12', 'start': 48700001,  'end': 51100000,  'type': 'gpos25'  },
      { 'id': 'q13.13', 'start': 51100001,  'end': 54500000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 54500001,  'end': 56200000,  'type': 'gpos25'  },
      { 'id': 'q13.3',  'start': 56200001,  'end': 57700000,  'type': 'gneg'    },
      { 'id': 'q14.1',  'start': 57700001,  'end': 62700000,  'type': 'gpos75'  },
      { 'id': 'q14.2',  'start': 62700001,  'end': 64700000,  'type': 'gneg'    },
      { 'id': 'q14.3',  'start': 64700001,  'end': 67300000,  'type': 'gpos50'  },
      { 'id': 'q15',    'start': 67300001,  'end': 71100000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 71100001,  'end': 75300000,  'type': 'gpos75'  },
      { 'id': 'q21.2',  'start': 75300001,  'end': 79900000,  'type': 'gneg'    },
      { 'id': 'q21.31', 'start': 79900001,  'end': 86300000,  'type': 'gpos100' },
      { 'id': 'q21.32', 'start': 86300001,  'end': 88600000,  'type': 'gneg'    },
      { 'id': 'q21.33', 'start': 88600001,  'end': 92200000,  'type': 'gpos100' },
      { 'id': 'q22',    'start': 92200001,  'end': 95800000,  'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 95800001,  'end': 101200000, 'type': 'gpos75'  },
      { 'id': 'q23.2',  'start': 101200001, 'end': 103500000, 'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 103500001, 'end': 108600000, 'type': 'gpos50'  },
      { 'id': 'q24.11', 'start': 108600001, 'end': 111300000, 'type': 'gneg'    },
      { 'id': 'q24.12', 'start': 111300001, 'end': 111900000, 'type': 'gpos25'  },
      { 'id': 'q24.13', 'start': 111900001, 'end': 113900000, 'type': 'gneg'    },
      { 'id': 'q24.21', 'start': 113900001, 'end': 116400000, 'type': 'gpos50'  },
      { 'id': 'q24.22', 'start': 116400001, 'end': 117700000, 'type': 'gneg'    },
      { 'id': 'q24.23', 'start': 117700001, 'end': 120300000, 'type': 'gpos50'  },
      { 'id': 'q24.31', 'start': 120300001, 'end': 125400000, 'type': 'gneg'    },
      { 'id': 'q24.32', 'start': 125400001, 'end': 128700000, 'type': 'gpos50'  },
      { 'id': 'q24.33', 'start': 128700001, 'end': 133275309, 'type': 'gneg'    },
    ],
  },
  '13': {
    'size'  : 114364328,
    'bands' : [
      { 'id': 'p11.1',  'start': 16500001,  'end': 17700000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 10100001,  'end': 16500000,  'type': 'gvar'    },
      { 'id': 'p12',    'start': 4600001,   'end': 10100000,  'type': 'stalk'   },
      { 'id': 'p13',    'start': 1,         'end': 4600000,   'type': 'gvar'    },
      { 'id': 'q11',    'start': 17700001,  'end': 18900000,  'type': 'acen'    },
      { 'id': 'q12.11', 'start': 18900001,  'end': 22600000,  'type': 'gneg'    },
      { 'id': 'q12.12', 'start': 22600001,  'end': 24900000,  'type': 'gpos25'  },
      { 'id': 'q12.13', 'start': 24900001,  'end': 27200000,  'type': 'gneg'    },
      { 'id': 'q12.2',  'start': 27200001,  'end': 28300000,  'type': 'gpos25'  },
      { 'id': 'q12.3',  'start': 28300001,  'end': 31600000,  'type': 'gneg'    },
      { 'id': 'q13.1',  'start': 31600001,  'end': 33400000,  'type': 'gpos50'  },
      { 'id': 'q13.2',  'start': 33400001,  'end': 34900000,  'type': 'gneg'    },
      { 'id': 'q13.3',  'start': 34900001,  'end': 39500000,  'type': 'gpos75'  },
      { 'id': 'q14.11', 'start': 39500001,  'end': 44600000,  'type': 'gneg'    },
      { 'id': 'q14.12', 'start': 44600001,  'end': 45200000,  'type': 'gpos25'  },
      { 'id': 'q14.13', 'start': 45200001,  'end': 46700000,  'type': 'gneg'    },
      { 'id': 'q14.2',  'start': 46700001,  'end': 50300000,  'type': 'gpos50'  },
      { 'id': 'q14.3',  'start': 50300001,  'end': 54700000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 54700001,  'end': 59000000,  'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 59000001,  'end': 61800000,  'type': 'gneg'    },
      { 'id': 'q21.31', 'start': 61800001,  'end': 65200000,  'type': 'gpos75'  },
      { 'id': 'q21.32', 'start': 65200001,  'end': 68100000,  'type': 'gneg'    },
      { 'id': 'q21.33', 'start': 68100001,  'end': 72800000,  'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 72800001,  'end': 74900000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 74900001,  'end': 76700000,  'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 76700001,  'end': 78500000,  'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 78500001,  'end': 87100000,  'type': 'gpos100' },
      { 'id': 'q31.2',  'start': 87100001,  'end': 89400000,  'type': 'gneg'    },
      { 'id': 'q31.3',  'start': 89400001,  'end': 94400000,  'type': 'gpos100' },
      { 'id': 'q32.1',  'start': 94400001,  'end': 97500000,  'type': 'gneg'    },
      { 'id': 'q32.2',  'start': 97500001,  'end': 98700000,  'type': 'gpos25'  },
      { 'id': 'q32.3',  'start': 98700001,  'end': 101100000, 'type': 'gneg'    },
      { 'id': 'q33.1',  'start': 101100001, 'end': 104200000, 'type': 'gpos100' },
      { 'id': 'q33.2',  'start': 104200001, 'end': 106400000, 'type': 'gneg'    },
      { 'id': 'q33.3',  'start': 106400001, 'end': 109600000, 'type': 'gpos100' },
      { 'id': 'q34',    'start': 109600001, 'end': 114364328, 'type': 'gneg'    },
    ],
  },
  '14': {
    'size'  : 107043718,
    'bands' : [
      { 'id': 'p11.1',  'start': 16100001,  'end': 17200000,  'type': 'acen'    },
      { 'id': 'p11.2',  'start': 8000001,   'end': 16100000,  'type': 'gvar'    },
      { 'id': 'p12',    'start': 3600001,   'end': 8000000,   'type': 'stalk'   },
      { 'id': 'p13',    'start': 1,         'end': 3600000,   'type': 'gvar'    },
      { 'id': 'q11.1',  'start': 17200001,  'end': 18200000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 18200001,  'end': 24100000,  'type': 'gneg'    },
      { 'id': 'q12',    'start': 24100001,  'end': 32900000,  'type': 'gpos100' },
      { 'id': 'q13.1',  'start': 32900001,  'end': 34800000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 34800001,  'end': 36100000,  'type': 'gpos50'  },
      { 'id': 'q13.3',  'start': 36100001,  'end': 37400000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 37400001,  'end': 43000000,  'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 43000001,  'end': 46700000,  'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 46700001,  'end': 50400000,  'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 50400001,  'end': 53600000,  'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 53600001,  'end': 55000000,  'type': 'gpos25'  },
      { 'id': 'q22.3',  'start': 55000001,  'end': 57600000,  'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 57600001,  'end': 61600000,  'type': 'gpos75'  },
      { 'id': 'q23.2',  'start': 61600001,  'end': 64300000,  'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 64300001,  'end': 67400000,  'type': 'gpos50'  },
      { 'id': 'q24.1',  'start': 67400001,  'end': 69800000,  'type': 'gneg'    },
      { 'id': 'q24.2',  'start': 69800001,  'end': 73300000,  'type': 'gpos50'  },
      { 'id': 'q24.3',  'start': 73300001,  'end': 78800000,  'type': 'gneg'    },
      { 'id': 'q31.1',  'start': 78800001,  'end': 83100000,  'type': 'gpos100' },
      { 'id': 'q31.2',  'start': 83100001,  'end': 84400000,  'type': 'gneg'    },
      { 'id': 'q31.3',  'start': 84400001,  'end': 89300000,  'type': 'gpos100' },
      { 'id': 'q32.11', 'start': 89300001,  'end': 91400000,  'type': 'gneg'    },
      { 'id': 'q32.12', 'start': 91400001,  'end': 94200000,  'type': 'gpos25'  },
      { 'id': 'q32.13', 'start': 94200001,  'end': 95800000,  'type': 'gneg'    },
      { 'id': 'q32.2',  'start': 95800001,  'end': 100900000, 'type': 'gpos50'  },
      { 'id': 'q32.31', 'start': 100900001, 'end': 102700000, 'type': 'gneg'    },
      { 'id': 'q32.32', 'start': 102700001, 'end': 103500000, 'type': 'gpos50'  },
      { 'id': 'q32.33', 'start': 103500001, 'end': 107043718, 'type': 'gneg'    },
    ],
  },
  '15': {
    'size'  : 101991189,
    'bands' : [
      { 'id': 'p11.1',  'start': 17500001, 'end': 19000000,  'type': 'acen'   },
      { 'id': 'p11.2',  'start': 9700001,  'end': 17500000,  'type': 'gvar'   },
      { 'id': 'p12',    'start': 4200001,  'end': 9700000,   'type': 'stalk'  },
      { 'id': 'p13',    'start': 1,        'end': 4200000,   'type': 'gvar'   },
      { 'id': 'q11.1',  'start': 19000001, 'end': 20500000,  'type': 'acen'   },
      { 'id': 'q11.2',  'start': 20500001, 'end': 25500000,  'type': 'gneg'   },
      { 'id': 'q12',    'start': 25500001, 'end': 27800000,  'type': 'gpos50' },
      { 'id': 'q13.1',  'start': 27800001, 'end': 30000000,  'type': 'gneg'   },
      { 'id': 'q13.2',  'start': 30000001, 'end': 30900000,  'type': 'gpos50' },
      { 'id': 'q13.3',  'start': 30900001, 'end': 33400000,  'type': 'gneg'   },
      { 'id': 'q14',    'start': 33400001, 'end': 39800000,  'type': 'gpos75' },
      { 'id': 'q15.1',  'start': 39800001, 'end': 42500000,  'type': 'gneg'   },
      { 'id': 'q15.2',  'start': 42500001, 'end': 43300000,  'type': 'gpos25' },
      { 'id': 'q15.3',  'start': 43300001, 'end': 44500000,  'type': 'gneg'   },
      { 'id': 'q21.1',  'start': 44500001, 'end': 49200000,  'type': 'gpos75' },
      { 'id': 'q21.2',  'start': 49200001, 'end': 52600000,  'type': 'gneg'   },
      { 'id': 'q21.3',  'start': 52600001, 'end': 58800000,  'type': 'gpos75' },
      { 'id': 'q22.1',  'start': 58800001, 'end': 59000000,  'type': 'gneg'   },
      { 'id': 'q22.2',  'start': 59000001, 'end': 63400000,  'type': 'gpos25' },
      { 'id': 'q22.31', 'start': 63400001, 'end': 66900000,  'type': 'gneg'   },
      { 'id': 'q22.32', 'start': 66900001, 'end': 67000000,  'type': 'gpos25' },
      { 'id': 'q22.33', 'start': 67000001, 'end': 67200000,  'type': 'gneg'   },
      { 'id': 'q23',    'start': 67200001, 'end': 72400000,  'type': 'gpos25' },
      { 'id': 'q24.1',  'start': 72400001, 'end': 74900000,  'type': 'gneg'   },
      { 'id': 'q24.2',  'start': 74900001, 'end': 76300000,  'type': 'gpos25' },
      { 'id': 'q24.3',  'start': 76300001, 'end': 78000000,  'type': 'gneg'   },
      { 'id': 'q25.1',  'start': 78000001, 'end': 81400000,  'type': 'gpos50' },
      { 'id': 'q25.2',  'start': 81400001, 'end': 84700000,  'type': 'gneg'   },
      { 'id': 'q25.3',  'start': 84700001, 'end': 88500000,  'type': 'gpos50' },
      { 'id': 'q26.1',  'start': 88500001, 'end': 93800000,  'type': 'gneg'   },
      { 'id': 'q26.2',  'start': 93800001, 'end': 98000000,  'type': 'gpos50' },
      { 'id': 'q26.3',  'start': 98000001, 'end': 101991189, 'type': 'gneg'   },
    ],
  },
  '16': {
    'size'  : 90338345,
    'bands' : [
      { 'id': 'p11.1',  'start': 35300001, 'end': 36800000, 'type': 'acen'    },
      { 'id': 'p11.2',  'start': 28500001, 'end': 35300000, 'type': 'gneg'    },
      { 'id': 'p12.1',  'start': 24200001, 'end': 28500000, 'type': 'gpos50'  },
      { 'id': 'p12.2',  'start': 21200001, 'end': 24200000, 'type': 'gneg'    },
      { 'id': 'p12.3',  'start': 16700001, 'end': 21200000, 'type': 'gpos50'  },
      { 'id': 'p13.11', 'start': 14700001, 'end': 16700000, 'type': 'gneg'    },
      { 'id': 'p13.12', 'start': 12500001, 'end': 14700000, 'type': 'gpos50'  },
      { 'id': 'p13.13', 'start': 10400001, 'end': 12500000, 'type': 'gneg'    },
      { 'id': 'p13.2',  'start': 7800001,  'end': 10400000, 'type': 'gpos50'  },
      { 'id': 'p13.3',  'start': 1,        'end': 7800000,  'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 36800001, 'end': 38400000, 'type': 'acen'    },
      { 'id': 'q11.2',  'start': 38400001, 'end': 47000000, 'type': 'gvar'    },
      { 'id': 'q12.1',  'start': 47000001, 'end': 52600000, 'type': 'gneg'    },
      { 'id': 'q12.2',  'start': 52600001, 'end': 56000000, 'type': 'gpos50'  },
      { 'id': 'q13',    'start': 56000001, 'end': 57300000, 'type': 'gneg'    },
      { 'id': 'q21',    'start': 57300001, 'end': 66600000, 'type': 'gpos100' },
      { 'id': 'q22.1',  'start': 66600001, 'end': 70800000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 70800001, 'end': 72800000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 72800001, 'end': 74100000, 'type': 'gneg'    },
      { 'id': 'q23.1',  'start': 74100001, 'end': 79200000, 'type': 'gpos75'  },
      { 'id': 'q23.2',  'start': 79200001, 'end': 81600000, 'type': 'gneg'    },
      { 'id': 'q23.3',  'start': 81600001, 'end': 84100000, 'type': 'gpos50'  },
      { 'id': 'q24.1',  'start': 84100001, 'end': 87000000, 'type': 'gneg'    },
      { 'id': 'q24.2',  'start': 87000001, 'end': 88700000, 'type': 'gpos25'  },
      { 'id': 'q24.3',  'start': 88700001, 'end': 90338345, 'type': 'gneg'    },
    ],
  },
  '17': {
    'size'  : 83257441,
    'bands' : [
      { 'id': 'p11.1',  'start': 22700001, 'end': 25100000, 'type': 'acen'   },
      { 'id': 'p11.2',  'start': 16100001, 'end': 22700000, 'type': 'gneg'   },
      { 'id': 'p12',    'start': 10800001, 'end': 16100000, 'type': 'gpos75' },
      { 'id': 'p13.1',  'start': 6500001,  'end': 10800000, 'type': 'gneg'   },
      { 'id': 'p13.2',  'start': 3400001,  'end': 6500000,  'type': 'gpos50' },
      { 'id': 'p13.3',  'start': 1,        'end': 3400000,  'type': 'gneg'   },
      { 'id': 'q11.1',  'start': 25100001, 'end': 27400000, 'type': 'acen'   },
      { 'id': 'q11.2',  'start': 27400001, 'end': 33500000, 'type': 'gneg'   },
      { 'id': 'q12',    'start': 33500001, 'end': 39800000, 'type': 'gpos50' },
      { 'id': 'q21.1',  'start': 39800001, 'end': 40200000, 'type': 'gneg'   },
      { 'id': 'q21.2',  'start': 40200001, 'end': 42800000, 'type': 'gpos25' },
      { 'id': 'q21.31', 'start': 42800001, 'end': 46800000, 'type': 'gneg'   },
      { 'id': 'q21.32', 'start': 46800001, 'end': 49300000, 'type': 'gpos25' },
      { 'id': 'q21.33', 'start': 49300001, 'end': 52100000, 'type': 'gneg'   },
      { 'id': 'q22',    'start': 52100001, 'end': 59500000, 'type': 'gpos75' },
      { 'id': 'q23.1',  'start': 59500001, 'end': 60200000, 'type': 'gneg'   },
      { 'id': 'q23.2',  'start': 60200001, 'end': 63100000, 'type': 'gpos75' },
      { 'id': 'q23.3',  'start': 63100001, 'end': 64600000, 'type': 'gneg'   },
      { 'id': 'q24.1',  'start': 64600001, 'end': 66200000, 'type': 'gpos50' },
      { 'id': 'q24.2',  'start': 66200001, 'end': 69100000, 'type': 'gneg'   },
      { 'id': 'q24.3',  'start': 69100001, 'end': 72900000, 'type': 'gpos75' },
      { 'id': 'q25.1',  'start': 72900001, 'end': 76800000, 'type': 'gneg'   },
      { 'id': 'q25.2',  'start': 76800001, 'end': 77200000, 'type': 'gpos25' },
      { 'id': 'q25.3',  'start': 77200001, 'end': 83257441, 'type': 'gneg'   },
    ],
  },
  '18': {
    'size'  : 80373285,
    'bands' : [
      { 'id': 'p11.1',  'start': 15400001, 'end': 18500000, 'type': 'acen'    },
      { 'id': 'p11.21', 'start': 10900001, 'end': 15400000, 'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 8500001,  'end': 10900000, 'type': 'gpos25'  },
      { 'id': 'p11.23', 'start': 7200001,  'end': 8500000,  'type': 'gneg'    },
      { 'id': 'p11.31', 'start': 2900001,  'end': 7200000,  'type': 'gpos50'  },
      { 'id': 'p11.32', 'start': 1,        'end': 2900000,  'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 18500001, 'end': 21500000, 'type': 'acen'    },
      { 'id': 'q11.2',  'start': 21500001, 'end': 27500000, 'type': 'gneg'    },
      { 'id': 'q12.1',  'start': 27500001, 'end': 35100000, 'type': 'gpos100' },
      { 'id': 'q12.2',  'start': 35100001, 'end': 39500000, 'type': 'gneg'    },
      { 'id': 'q12.3',  'start': 39500001, 'end': 45900000, 'type': 'gpos75'  },
      { 'id': 'q21.1',  'start': 45900001, 'end': 50700000, 'type': 'gneg'    },
      { 'id': 'q21.2',  'start': 50700001, 'end': 56200000, 'type': 'gpos75'  },
      { 'id': 'q21.31', 'start': 56200001, 'end': 58600000, 'type': 'gneg'    },
      { 'id': 'q21.32', 'start': 58600001, 'end': 61300000, 'type': 'gpos50'  },
      { 'id': 'q21.33', 'start': 61300001, 'end': 63900000, 'type': 'gneg'    },
      { 'id': 'q22.1',  'start': 63900001, 'end': 69100000, 'type': 'gpos100' },
      { 'id': 'q22.2',  'start': 69100001, 'end': 71000000, 'type': 'gneg'    },
      { 'id': 'q22.3',  'start': 71000001, 'end': 75400000, 'type': 'gpos25'  },
      { 'id': 'q23',    'start': 75400001, 'end': 80373285, 'type': 'gneg'    },
    ],
  },
  '19': {
    'size'  : 58617616,
    'bands' : [
      { 'id': 'p11',    'start': 24200001, 'end': 26200000, 'type': 'acen'   },
      { 'id': 'p12',    'start': 19900001, 'end': 24200000, 'type': 'gvar'   },
      { 'id': 'p13.11', 'start': 16100001, 'end': 19900000, 'type': 'gneg'   },
      { 'id': 'p13.12', 'start': 13800001, 'end': 16100000, 'type': 'gpos25' },
      { 'id': 'p13.13', 'start': 12600001, 'end': 13800000, 'type': 'gneg'   },
      { 'id': 'p13.2',  'start': 6900001,  'end': 12600000, 'type': 'gpos25' },
      { 'id': 'p13.3',  'start': 1,        'end': 6900000,  'type': 'gneg'   },
      { 'id': 'q11',    'start': 26200001, 'end': 28100000, 'type': 'acen'   },
      { 'id': 'q12',    'start': 28100001, 'end': 31900000, 'type': 'gvar'   },
      { 'id': 'q13.11', 'start': 31900001, 'end': 35100000, 'type': 'gneg'   },
      { 'id': 'q13.12', 'start': 35100001, 'end': 37800000, 'type': 'gpos25' },
      { 'id': 'q13.13', 'start': 37800001, 'end': 38200000, 'type': 'gneg'   },
      { 'id': 'q13.2',  'start': 38200001, 'end': 42900000, 'type': 'gpos25' },
      { 'id': 'q13.31', 'start': 42900001, 'end': 44700000, 'type': 'gneg'   },
      { 'id': 'q13.32', 'start': 44700001, 'end': 47500000, 'type': 'gpos25' },
      { 'id': 'q13.33', 'start': 47500001, 'end': 50900000, 'type': 'gneg'   },
      { 'id': 'q13.41', 'start': 50900001, 'end': 53100000, 'type': 'gpos25' },
      { 'id': 'q13.42', 'start': 53100001, 'end': 55800000, 'type': 'gneg'   },
      { 'id': 'q13.43', 'start': 55800001, 'end': 58617616, 'type': 'gpos25' },
    ],
  },
  '20': {
    'size'  : 64444167,
    'bands' : [
      { 'id': 'p11.1',  'start': 25700001, 'end': 28100000, 'type': 'acen'   },
      { 'id': 'p11.21', 'start': 22300001, 'end': 25700000, 'type': 'gneg'   },
      { 'id': 'p11.22', 'start': 21300001, 'end': 22300000, 'type': 'gpos25' },
      { 'id': 'p11.23', 'start': 17900001, 'end': 21300000, 'type': 'gneg'   },
      { 'id': 'p12.1',  'start': 12000001, 'end': 17900000, 'type': 'gpos75' },
      { 'id': 'p12.2',  'start': 9200001,  'end': 12000000, 'type': 'gneg'   },
      { 'id': 'p12.3',  'start': 5100001,  'end': 9200000,  'type': 'gpos75' },
      { 'id': 'p13',    'start': 1,        'end': 5100000,  'type': 'gneg'   },
      { 'id': 'q11.1',  'start': 28100001, 'end': 30400000, 'type': 'acen'   },
      { 'id': 'q11.21', 'start': 30400001, 'end': 33500000, 'type': 'gneg'   },
      { 'id': 'q11.22', 'start': 33500001, 'end': 35800000, 'type': 'gpos25' },
      { 'id': 'q11.23', 'start': 35800001, 'end': 39000000, 'type': 'gneg'   },
      { 'id': 'q12',    'start': 39000001, 'end': 43100000, 'type': 'gpos75' },
      { 'id': 'q13.11', 'start': 43100001, 'end': 43500000, 'type': 'gneg'   },
      { 'id': 'q13.12', 'start': 43500001, 'end': 47800000, 'type': 'gpos25' },
      { 'id': 'q13.13', 'start': 47800001, 'end': 51200000, 'type': 'gneg'   },
      { 'id': 'q13.2',  'start': 51200001, 'end': 56400000, 'type': 'gpos75' },
      { 'id': 'q13.31', 'start': 56400001, 'end': 57800000, 'type': 'gneg'   },
      { 'id': 'q13.32', 'start': 57800001, 'end': 59700000, 'type': 'gpos50' },
      { 'id': 'q13.33', 'start': 59700001, 'end': 64444167, 'type': 'gneg'   },
    ],
  },
  '21': {
    'size'  : 46709983,
    'bands' : [
      { 'id': 'p11.1',  'start': 10900001, 'end': 12000000, 'type': 'acen'    },
      { 'id': 'p11.2',  'start': 7000001,  'end': 10900000, 'type': 'gvar'    },
      { 'id': 'p12',    'start': 3100001,  'end': 7000000,  'type': 'stalk'   },
      { 'id': 'p13',    'start': 1,        'end': 3100000,  'type': 'gvar'    },
      { 'id': 'q11.1',  'start': 12000001, 'end': 13000000, 'type': 'acen'    },
      { 'id': 'q11.2',  'start': 13000001, 'end': 15000000, 'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 15000001, 'end': 22600000, 'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 22600001, 'end': 25500000, 'type': 'gneg'    },
      { 'id': 'q21.3',  'start': 25500001, 'end': 30200000, 'type': 'gpos75'  },
      { 'id': 'q22.11', 'start': 30200001, 'end': 34400000, 'type': 'gneg'    },
      { 'id': 'q22.12', 'start': 34400001, 'end': 36400000, 'type': 'gpos50'  },
      { 'id': 'q22.13', 'start': 36400001, 'end': 38300000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 38300001, 'end': 41200000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 41200001, 'end': 46709983, 'type': 'gneg'    },
    ],
  },
  '22': {
    'size'  : 50818468,
    'bands' : [
      { 'id': 'p11.1',  'start': 13700001, 'end': 15000000, 'type': 'acen'   },
      { 'id': 'p11.2',  'start': 9400001,  'end': 13700000, 'type': 'gvar'   },
      { 'id': 'p12',    'start': 4300001,  'end': 9400000,  'type': 'stalk'  },
      { 'id': 'p13',    'start': 1,        'end': 4300000,  'type': 'gvar'   },
      { 'id': 'q11.1',  'start': 15000001, 'end': 17400000, 'type': 'acen'   },
      { 'id': 'q11.21', 'start': 17400001, 'end': 21700000, 'type': 'gneg'   },
      { 'id': 'q11.22', 'start': 21700001, 'end': 23100000, 'type': 'gpos25' },
      { 'id': 'q11.23', 'start': 23100001, 'end': 25500000, 'type': 'gneg'   },
      { 'id': 'q12.1',  'start': 25500001, 'end': 29200000, 'type': 'gpos50' },
      { 'id': 'q12.2',  'start': 29200001, 'end': 31800000, 'type': 'gneg'   },
      { 'id': 'q12.3',  'start': 31800001, 'end': 37200000, 'type': 'gpos50' },
      { 'id': 'q13.1',  'start': 37200001, 'end': 40600000, 'type': 'gneg'   },
      { 'id': 'q13.2',  'start': 40600001, 'end': 43800000, 'type': 'gpos50' },
      { 'id': 'q13.31', 'start': 43800001, 'end': 48100000, 'type': 'gneg'   },
      { 'id': 'q13.32', 'start': 48100001, 'end': 49100000, 'type': 'gpos50' },
      { 'id': 'q13.33', 'start': 49100001, 'end': 50818468, 'type': 'gneg'   },
    ],
  },
  'X': {
    'size'  : 156040895,
    'bands' : [
      { 'id': 'p11.1',  'start': 58100001,  'end': 61000000,  'type': 'acen'    },
      { 'id': 'p11.21', 'start': 54800001,  'end': 58100000,  'type': 'gneg'    },
      { 'id': 'p11.22', 'start': 50100001,  'end': 54800000,  'type': 'gpos25'  },
      { 'id': 'p11.23', 'start': 47600001,  'end': 50100000,  'type': 'gneg'    },
      { 'id': 'p11.3',  'start': 42500001,  'end': 47600000,  'type': 'gpos75'  },
      { 'id': 'p11.4',  'start': 37800001,  'end': 42500000,  'type': 'gneg'    },
      { 'id': 'p21.1',  'start': 31500001,  'end': 37800000,  'type': 'gpos100' },
      { 'id': 'p21.2',  'start': 29300001,  'end': 31500000,  'type': 'gneg'    },
      { 'id': 'p21.3',  'start': 24900001,  'end': 29300000,  'type': 'gpos100' },
      { 'id': 'p22.11', 'start': 21900001,  'end': 24900000,  'type': 'gneg'    },
      { 'id': 'p22.12', 'start': 19200001,  'end': 21900000,  'type': 'gpos50'  },
      { 'id': 'p22.13', 'start': 17400001,  'end': 19200000,  'type': 'gneg'    },
      { 'id': 'p22.2',  'start': 9600001,   'end': 17400000,  'type': 'gpos50'  },
      { 'id': 'p22.31', 'start': 6100001,   'end': 9600000,   'type': 'gneg'    },
      { 'id': 'p22.32', 'start': 4400001,   'end': 6100000,   'type': 'gpos50'  },
      { 'id': 'p22.33', 'start': 1,         'end': 4400000,   'type': 'gneg'    },
      { 'id': 'q11.1',  'start': 61000001,  'end': 63800000,  'type': 'acen'    },
      { 'id': 'q11.2',  'start': 63800001,  'end': 65400000,  'type': 'gneg'    },
      { 'id': 'q12',    'start': 65400001,  'end': 68500000,  'type': 'gpos50'  },
      { 'id': 'q13.1',  'start': 68500001,  'end': 73000000,  'type': 'gneg'    },
      { 'id': 'q13.2',  'start': 73000001,  'end': 74700000,  'type': 'gpos50'  },
      { 'id': 'q13.3',  'start': 74700001,  'end': 76800000,  'type': 'gneg'    },
      { 'id': 'q21.1',  'start': 76800001,  'end': 85400000,  'type': 'gpos100' },
      { 'id': 'q21.2',  'start': 85400001,  'end': 87000000,  'type': 'gneg'    },
      { 'id': 'q21.31', 'start': 87000001,  'end': 92700000,  'type': 'gpos100' },
      { 'id': 'q21.32', 'start': 92700001,  'end': 94300000,  'type': 'gneg'    },
      { 'id': 'q21.33', 'start': 94300001,  'end': 99100000,  'type': 'gpos75'  },
      { 'id': 'q22.1',  'start': 99100001,  'end': 103300000, 'type': 'gneg'    },
      { 'id': 'q22.2',  'start': 103300001, 'end': 104500000, 'type': 'gpos50'  },
      { 'id': 'q22.3',  'start': 104500001, 'end': 109400000, 'type': 'gneg'    },
      { 'id': 'q23',    'start': 109400001, 'end': 117400000, 'type': 'gpos75'  },
      { 'id': 'q24',    'start': 117400001, 'end': 121800000, 'type': 'gneg'    },
      { 'id': 'q25',    'start': 121800001, 'end': 129500000, 'type': 'gpos100' },
      { 'id': 'q26.1',  'start': 129500001, 'end': 131300000, 'type': 'gneg'    },
      { 'id': 'q26.2',  'start': 131300001, 'end': 134500000, 'type': 'gpos25'  },
      { 'id': 'q26.3',  'start': 134500001, 'end': 138900000, 'type': 'gneg'    },
      { 'id': 'q27.1',  'start': 138900001, 'end': 141200000, 'type': 'gpos75'  },
      { 'id': 'q27.2',  'start': 141200001, 'end': 143000000, 'type': 'gneg'    },
      { 'id': 'q27.3',  'start': 143000001, 'end': 148000000, 'type': 'gpos100' },
      { 'id': 'q28',    'start': 148000001, 'end': 156040895, 'type': 'gneg'    },
    ],
  },
  'Y': {
    'size'  : 57227415,
    'bands' : [
      { 'id': 'p11.1',   'start': 10300001, 'end': 10400000, 'type': 'acen'   },
      { 'id': 'p11.2',   'start': 600001,   'end': 10300000, 'type': 'gneg'   },
      { 'id': 'p11.31',  'start': 300001,   'end': 600000,   'type': 'gpos50' },
      { 'id': 'p11.32',  'start': 1,        'end': 300000,   'type': 'gneg'   },
      { 'id': 'q11.1',   'start': 10400001, 'end': 10600000, 'type': 'acen'   },
      { 'id': 'q11.21',  'start': 10600001, 'end': 12400000, 'type': 'gneg'   },
      { 'id': 'q11.221', 'start': 12400001, 'end': 17100000, 'type': 'gpos50' },
      { 'id': 'q11.222', 'start': 17100001, 'end': 19600000, 'type': 'gneg'   },
      { 'id': 'q11.223', 'start': 19600001, 'end': 23800000, 'type': 'gpos50' },
      { 'id': 'q11.23',  'start': 23800001, 'end': 26600000, 'type': 'gneg'   },
      { 'id': 'q12',     'start': 26600001, 'end': 57227415, 'type': 'gvar'   },
    ],
  },
  'MT': {
    'size'  : 16569,
    'bands' : [
      { 'start': 1, 'end': 16569 },
    ],
  },
};
